<template>
	<v-img :src="imageSrc" />
</template>

<script>
import featureBackground1 from '@/assets/png/feature-background-1.png';
import featureBackground2 from '@/assets/png/feature-background-2.png';
import featureBackground3 from '@/assets/png/feature-background-3.png';
import featureBackground4 from '@/assets/png/feature-background-4.png';
import featureBackground5 from '@/assets/png/feature-background-5.png';
import featureBackground6 from '@/assets/png/feature-background-6.png';
export default {
	name: 'FeatureBackgroundImage',
	props: { name: { type: String, required: true } },
	computed: {
		imageSrc() {
			return this.backgroundImages.find((img) => img.name === this.name)?.image || this.name;
		},
	},
	data: () => ({
		backgroundImages: [
			{ name: 'feature-background-1', image: featureBackground1 },
			{ name: 'feature-background-2', image: featureBackground2 },
			{ name: 'feature-background-3', image: featureBackground3 },
			{ name: 'feature-background-4', image: featureBackground4 },
			{ name: 'feature-background-5', image: featureBackground5 },
			{ name: 'feature-background-6', image: featureBackground6 },
		],
	}),
};
</script>

<style scoped lang="scss"></style>
